import React, { useState, useEffect } from "react";
import {
  url,
  urlDistribution,
  urlDelivery,
  endpointChannels,
  endpointDownloadZip,
  endpointSetNotifications,
  endpointSetDoneNotifications,
  endpointDeleteNotifications,
  endpointGeneratePackage
} from "../services/Endpoints";
import { Loading } from "./Loading";
import { faDownload, faChevronDown, faChevronUp, faTrash, faPaperPlane, faSync, faList, faCheck, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoadingIcon from "./LoadingIcon";
import Modal from "./ModalConversion";
import ConfirmationModal from "./ConfirmationModal";
import AddNotificationModal from "./AddNotificationModal";
import WindowStatusProcess from "./WindowStatusProcess";
import { ActionsMenu } from "./AccountsUsers/ActionsMenu";

const NotificationsModal = ({
  isOpen,
  onClose,
  channel,
  downloading,
  onDownload,
  selectedItems,
  onToggleSelectAll,
  onToggleSelectItem,
  onConfirmAction,
  handleNotificationAction,
  loading
}) => {
  if (!channel) return null;

  const selectedForChannel = selectedItems[channel.channel] || [];
  const isAllSelected = channel.notifications?.length > 0 && selectedForChannel.length === channel.notifications.length;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="p-2">
        <div className="d-flex justify-content-between align-items-center mb-4 border-bottom border-secondary border-opacity-25 pb-3">
          <div className="d-flex align-items-center gap-3">
            <div className="bg-primary bg-opacity-10 p-2 rounded-3">
              <FontAwesomeIcon icon={faList} className="text-primary" />
            </div>
            <div>
              <h3 className="mb-0 text-white">{channel.channel}</h3>
              <p className="text-white-50 small mb-0">{channel.notification_count} notificaciones pendientes</p>
            </div>
          </div>
        </div>

        {selectedForChannel.length > 0 && (
          <div className="bg-primary bg-opacity-10 border border-primary border-opacity-25 rounded-3 p-3 mb-4 d-flex justify-content-between align-items-center animate__animated animate__fadeIn">
            <div className="d-flex align-items-center gap-2">
              <span className="badge bg-primary rounded-pill px-3 py-2 fs-6">
                {selectedForChannel.length} seleccionados
              </span>
            </div>
            <div className="d-flex gap-2">
              <button
                className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                title="Enviar seleccionados a tienda"
                style={{ width: '40px', height: '40px' }}
                onClick={() => onConfirmAction({
                  type: 'info',
                  title: 'Enviar a tienda',
                  message: `¿Deseas enviar ${selectedForChannel.length} notificaciones a la tienda?`,
                  onConfirm: () => handleNotificationAction('send', channel, selectedForChannel)
                })}
              >
                <FontAwesomeIcon icon={faPaperPlane} />
              </button>
              <button
                className="btn btn-success rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                title="Marcar seleccionados como enviados"
                style={{ width: '40px', height: '40px' }}
                onClick={() => onConfirmAction({
                  type: 'success',
                  title: 'Marcar como enviado',
                  message: `¿Deseas marcar ${selectedForChannel.length} notificaciones como enviadas?`,
                  onConfirm: () => onConfirmAction({
                    type: 'success',
                    title: 'Confirmación',
                    message: `Procesando ${selectedForChannel.length} notificaciones...`,
                    onConfirm: () => handleNotificationAction('done', channel, selectedForChannel)
                  })
                })}
              >
                <FontAwesomeIcon icon={faCheck} />
              </button>
              <button
                className="btn btn-outline-danger rounded-circle d-flex align-items-center justify-content-center"
                title="Eliminar seleccionados"
                style={{ width: '40px', height: '40px' }}
                onClick={() => onConfirmAction({
                  type: 'danger',
                  title: 'Eliminar notificaciones',
                  message: `¿Deseas eliminar ${selectedForChannel.length} notificaciones? Esta acción no se puede deshacer.`,
                  onConfirm: () => handleNotificationAction('delete', channel, selectedForChannel)
                })}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </div>
          </div>
        )}

        <div className="position-relative">
          {loading && (
            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-dark bg-opacity-75 rounded-3 z-99" style={{ minHeight: '300px' }}>
              <div className="text-center p-4 bg-dark bg-opacity-50 rounded-4 border border-secondary border-opacity-25 shadow-lg animate__animated animate__fadeIn">
                <LoadingIcon />
                <p className="text-white-50 mt-3 mb-0 fw-bold">Procesando...</p>
                <p className="text-white-50 small">Por favor, espera un momento</p>
              </div>
            </div>
          )}

          <div className="table-responsive" style={{ maxHeight: '60vh' }}>
            <table className="table table-dark table-hover align-middle mb-0">
              <thead className="sticky-top bg-dark">
                <tr>
                  <th className="text-center" style={{ width: '40px' }}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={isAllSelected}
                      onChange={(e) => onToggleSelectAll(channel.channel, e.target.checked)}
                    />
                  </th>
                  <th>Ink id</th>
                  <th>Notificación</th>
                  <th className="text-end">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {channel.notifications.map((notification, nIndex) => {
                  const accountInkId = `${notification.account}-${notification.ink_id}`;
                  const isItemSelected = selectedForChannel.includes(accountInkId);
                  return (
                    <tr key={nIndex} className={isItemSelected ? 'table-active' : ''}>
                      <td className="text-center">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={isItemSelected}
                          onChange={(e) => onToggleSelectItem(channel.channel, accountInkId, e.target.checked)}
                        />
                      </td>
                      <td>
                        <div className="d-flex flex-column">
                          <span className="fw-bold text-info">{notification.account}</span>
                          <span className="small text-white-50">{notification.ink_id}</span>
                        </div>
                      </td>
                      <td>
                        <span className="badge bg-secondary bg-opacity-25 text-white fw-normal">
                          {notification.notification_type}
                        </span>
                      </td>
                      <td>
                        <div className="d-flex gap-2 justify-content-end">
                          {(channel.alias === 'spotify' || channel.alias === 'ingram') && (
                            <button
                              className="btn btn-outline-info btn-sm rounded-circle d-flex align-items-center justify-content-center"
                              onClick={(e) => onDownload(e, channel.alias, notification.account, notification.ink_id)}
                              disabled={downloading[notification.ink_id]}
                              title="Descargar ZIP"
                              style={{ width: '32px', height: '32px' }}
                            >
                              {downloading[notification.ink_id] ? <LoadingIcon /> : <FontAwesomeIcon icon={faDownload} />}
                            </button>
                          )}
                          <button
                            className="btn btn-outline-success btn-sm rounded-circle d-flex align-items-center justify-content-center"
                            title="Enviar a tienda"
                            style={{ width: '32px', height: '32px' }}
                            onClick={() => onConfirmAction({
                              type: 'info',
                              title: 'Enviar a tienda',
                              message: `¿Deseas enviar el titulo ${notification.account}-${notification.ink_id} a la tienda?`,
                              onConfirm: () => handleNotificationAction('send', channel, accountInkId, notification.notification_type)
                            })}
                          >
                            <FontAwesomeIcon icon={faPaperPlane} />
                          </button>
                          <button
                            className="btn btn-outline-primary btn-sm rounded-circle d-flex align-items-center justify-content-center"
                            title="Marcar como enviado"
                            style={{ width: '32px', height: '32px' }}
                            onClick={() => onConfirmAction({
                              type: 'success',
                              title: 'Marcar como enviado',
                              message: `¿Deseas marcar el titulo ${notification.account}-${notification.ink_id} como enviado?`,
                              onConfirm: () => handleNotificationAction('done', channel, accountInkId, notification.notification_type)
                            })}
                          >
                            <FontAwesomeIcon icon={faCheck} />
                          </button>
                          <button
                            className="btn btn-outline-danger btn-sm rounded-circle d-flex align-items-center justify-content-center"
                            title="Eliminar notificación"
                            style={{ width: '32px', height: '32px' }}
                            onClick={() => onConfirmAction({
                              type: 'danger',
                              title: 'Eliminar notificación',
                              message: `¿Deseas eliminar el titulo ${notification.account}-${notification.ink_id}? Esta acción no se puede deshacer.`,
                              onConfirm: () => handleNotificationAction('delete', channel, accountInkId, notification.notification_type)
                            })}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-4 pt-3 border-top border-secondary border-opacity-25">
          <button className="btn btn-outline-secondary px-4" onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </Modal>
  );
};

function Channels(props) {

  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [selectedItems, setSelectedItems] = useState({}); // { channelName: [inkId, ...] }
  const [selectedChannelModal, setSelectedChannelModal] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    type: 'warning',
    title: '',
    message: '',
    onConfirm: () => { }
  });
  const [requestStatus, setRequestStatus] = useState('none');
  const [responseText, setResponseText] = useState([]);

  useEffect(() => {
    getChannels();
    return () => {
      setChannels(() => [])
    }
  }, []);

  useEffect(() => {
    if (selectedChannelModal) {
      const updatedChannel = channels.find(c => c.channel === selectedChannelModal.channel);
      if (updatedChannel) {
        setSelectedChannelModal(updatedChannel);
      } else {
        setSelectedChannelModal(null);
      }
    }
  }, [channels]);

  const handleClickUpdate = (e) => {
    e.preventDefault();
    getChannels()
  }

  const handleToggleSelectAll = (channelName, checked) => {
    const channel = channels.find(c => c.channel === channelName);
    if (!channel) return;

    if (checked) {
      const allIds = channel.notifications.map(n => `${n.account}-${n.ink_id}`);
      setSelectedItems(prev => ({ ...prev, [channelName]: allIds }));
    } else {
      setSelectedItems(prev => ({ ...prev, [channelName]: [] }));
    }
  };

  const handleToggleSelectItem = (channelName, accountInkId, checked) => {
    setSelectedItems(prev => {
      const currentSelected = prev[channelName] || [];
      if (checked) {
        return { ...prev, [channelName]: [...currentSelected, accountInkId] };
      } else {
        return { ...prev, [channelName]: currentSelected.filter(id => id !== accountInkId) };
      }
    });
  };

  const handleClickDownload = (e, alias, account, inkId) => {
    e.stopPropagation();
    setDownloading((prev) => ({ ...prev, [inkId]: true }));

    fetch(`${urlDelivery}${endpointDownloadZip}?channel=${alias}&account=${account}&ink_id=${inkId}`)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', account + '-' + inkId + '.zip');
        document.body.appendChild(link);
        link.click();
        setDownloading((prev) => ({ ...prev, [inkId]: false }));
      })
      .catch((error) => {
        setDownloading((prev) => ({ ...prev, [inkId]: false }));
        console.error(error);
      });
  }

  const getChannels = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${urlDistribution}${endpointChannels}?content_type=all`, {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      });
      const res = await response.json();
      if (res && res.status == 'success') {
        const sortedChannels = res.data.channels.sort((a, b) => b.notification_count - a.notification_count);
        setChannels(sortedChannels);
      }
      setLoading(false);

    } catch (error) {
      setLoading(false);
      console.error("Request failed:", error);
    }
  };

  const handleNotificationAction = async (action, channel, inkIds = null, notificationType = null) => {
    try {
      setLoading(true);
      const channelName = channel.channel;
      const channelAlias = channel.alias || channelName;

      let endpoint;
      let baseUrl = urlDistribution;

      if (action === 'delete') {
        endpoint = endpointDeleteNotifications;
      } else if (action === 'done') {
        endpoint = endpointSetDoneNotifications;
      } else if (action === 'send') {
        endpoint = endpointGeneratePackage;
        baseUrl = urlDelivery;
      } else if (action === 'download') {
        endpoint = endpointDownloadZip;
        baseUrl = urlDelivery;
      }

      let query = `channels=${channelAlias}`;

      // Optimization: If the number of selected inkIds matches the total notifications for the channel,
      // we only send the channel and omit the specific ink_ids.
      const isAllSelected = inkIds && Array.isArray(inkIds) &&
        channel.notifications &&
        inkIds.length === channel.notifications.length;

      if (inkIds && !isAllSelected) {
        const inkIdsStr = Array.isArray(inkIds) ? inkIds.join(',') : inkIds;
        query += `&ink_ids=${inkIdsStr}`;
      }

      if (notificationType) {
        query += `&notification_type=${notificationType}`;
      }

      const response = await fetch(`${baseUrl}${endpoint}?${query}`);
      const res = await response.json();

      if (res && res.status === 'success') {
        setSelectedItems(prev => ({ ...prev, [channelName]: [] }));
        await getChannels(); // Refresh data
      } else {
        console.error(`Error in ${action} action:`, res.msg);
        alert(res.msg || `Error al procesar la acción de ${action}`);
      }
    } catch (error) {
      console.error(`Failed to perform ${action} action:`, error);
      alert(`Error de red al procesar la acción de ${action}`);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmAction = (config) => {
    setConfirmModal({
      isOpen: true,
      ...config,
      onConfirm: () => {
        config.onConfirm();
        setConfirmModal(prev => ({ ...prev, isOpen: false }));
      }
    });
  };

  const handleAddNotification = async (data) => {
    try {
      setRequestStatus('pending');
      setResponseText([]);

      const response = await fetch(`${url}${endpointSetNotifications}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          channels: data.channels,
          inkIds: data.inkIds,
          notificationType: data.notificationType,
          done: data.done
        })
      });
      const res = await response.json();

      if (res && res.status === 'success') {
        setRequestStatus('completed');
        setResponseText([res.msg || "Notificaciones agregadas correctamente"]);
        getChannels();
      } else {
        setRequestStatus('completed');
        setResponseText(res.details || [res.msg || "Error al agregar notificaciones"]);
      }
    } catch (error) {
      setRequestStatus('completed');
      setResponseText(["Error en el servidor al procesar notificaciones"]);
      console.error("Failed to add notifications:", error);
    }
  };

  return (
    <div className="py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="text-white mb-1">Canales de Distribución</h2>
          <p className="text-white-50 small mb-0">Gestiona las notificaciones y envíos por canal</p>
        </div>
        <div className="d-flex gap-2">
          <button className="btn btn-primary d-flex align-items-center gap-2 shadow-sm" onClick={() => setIsAddModalOpen(true)}>
            <FontAwesomeIcon icon={faPlus} />
            Agregar Notificación
          </button>
          <button className="btn btn-ink-icon" onClick={handleClickUpdate} title="Recargar lista">
            <FontAwesomeIcon icon={faSync} spin={loading} />
          </button>
        </div>
      </div>

      {loading && <Loading />}

      <div className="modern-table-container">
        <table className="modern-table striped-table">
          <thead>
            <tr>
              <th>Canal</th>
              <th>Notificaciones</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {channels.map((channel, index) => {
              const items = [
                { label: 'Ver Detalles', onClick: () => setSelectedChannelModal(channel) },
              ];
              if (channel.notification_count > 0) {
                items.push(
                  {
                    label: 'Enviar todo a tienda',
                    onClick: () => handleConfirmAction({
                      type: 'info',
                      title: 'Enviar a tienda',
                      message: `¿Deseas enviar todas las notificaciones pendientes de ${channel.alias || channel.channel} a la tienda?`,
                      onConfirm: () => handleNotificationAction('send', channel)
                    })
                  },
                  {
                    label: 'Marcar todos como enviados',
                    onClick: () => handleConfirmAction({
                      type: 'success',
                      title: 'Marcar todos como enviados',
                      message: `¿Deseas marcar las ${channel.notification_count} notificaciones de ${channel.channel} como enviadas?`,
                      onConfirm: () => handleNotificationAction('done', channel)
                    })
                  },
                  {
                    label: 'Eliminar todas las notificaciones',
                    danger: true,
                    onClick: () => handleConfirmAction({
                      type: 'danger',
                      title: 'Eliminar todas las notificaciones',
                      message: `¿Deseas eliminar las ${channel.notification_count} notificaciones de ${channel.channel}? Esta acción no se puede deshacer.`,
                      onConfirm: () => handleNotificationAction('delete', channel)
                    })
                  },
                );
              }
              return (
                <tr key={index}>
                  <td className="short fw-bold text-white">
                    <div className="d-flex align-items-center gap-2">
                      <FontAwesomeIcon icon={faList} className="text-white-50" />
                      <span>{channel.channel}</span>
                    </div>
                  </td>
                  <td className="short">
                    {channel.notification_count > 0 ? (
                      <span className="badge-status status-off">
                        {channel.notification_count} pendientes
                      </span>
                    ) : (
                      <span className="text-white-50">Sin pendientes</span>
                    )}
                  </td>
                  <td>
                    <ActionsMenu items={items} title="Acciones del canal" />
                  </td>
                </tr>
              );
            })}
            {channels.length === 0 && !loading && (
              <tr>
                <td colSpan="3" className="text-center py-5 text-white-50">
                  No se encontraron canales activos
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <NotificationsModal
        isOpen={!!selectedChannelModal}
        onClose={() => setSelectedChannelModal(null)}
        channel={selectedChannelModal}
        downloading={downloading}
        onDownload={handleClickDownload}
        selectedItems={selectedItems}
        onToggleSelectAll={handleToggleSelectAll}
        onToggleSelectItem={handleToggleSelectItem}
        onConfirmAction={handleConfirmAction}
        handleNotificationAction={handleNotificationAction}
        loading={loading}
      />

      <ConfirmationModal
        isOpen={confirmModal.isOpen}
        onClose={() => setConfirmModal(prev => ({ ...prev, isOpen: false }))}
        onConfirm={confirmModal.onConfirm}
        type={confirmModal.type}
        title={confirmModal.title}
        message={confirmModal.message}
      />

      <AddNotificationModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onAdd={handleAddNotification}
        availableChannels={channels}
      />

      <WindowStatusProcess
        requestStatus={requestStatus}
        responseText={responseText}
      />
    </div>
  );
}

export default Channels;